import { SearchDepartment } from '@moonpig/web-core-nav/src/Search'

const ALLOWED_ROUTES = ['basket', 'p', 'reminders', 'myaccount', 'account']

const isAllowedRoute = (parts: string[]): boolean =>
  parts.length === 0 || parts.some(part => ALLOWED_ROUTES.includes(part))

const isEligibleItemType = (itemType: string | undefined): boolean => {
  return (
    itemType === 'search-fallback' ||
    itemType === 'search' ||
    itemType === undefined
  )
}

const hasDepartmentChanged = (department?: SearchDepartment): boolean => {
  return department?.activeDepartment?.name !== 'all'
}

export const allowSmartDepartmentRedirect = ({
  itemType,
  parts,
  department,
}: {
  itemType: string | undefined
  parts: string[]
  department?: SearchDepartment
}): boolean => {
  return (
    isEligibleItemType(itemType) &&
    isAllowedRoute(parts) &&
    !hasDepartmentChanged(department)
  )
}
